import { ApolloClient } from "@apollo/client/core";
import {
  updateUserBook as updateUserBookService,
  insertUserBook as insertUserBookService,
  deleteUserBook as deleteUserBookService,
} from "./index";
import { UserBookSerializersUserBook } from "types/serializers";
import { NewUserBookType } from "types/UserBookType";

// UPDATE
export async function updateUserBook({
  id,
  userBook,
  client,
}: {
  id: number;
  userBook: UserBookSerializersUserBook;
  client: ApolloClient<any>;
}) {
  return updateUserBookService({ client, id, userBook });
}

// INSERT
export async function insertUserBook({ userBook, client }: { userBook: NewUserBookType, client: ApolloClient<any> }) {
  return insertUserBookService({ client, userBook });
}

// Delete
export async function deleteUserBook(id: number, client: ApolloClient<any>) {
  return deleteUserBookService({ client, id });
}
